import { Box, Divider, IconButton, Tooltip } from "@mui/material";
import AlignHorizontalCenterIcon from "@mui/icons-material/AlignHorizontalCenter";
import AlignVerticalCenterIcon from "@mui/icons-material/AlignVerticalCenter";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import VerticalAlignTopIcon from "@mui/icons-material/VerticalAlignTop";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import useLanguage from "../../../hooks/useLanguage";

const CANVAS_W = 1080;
const CANVAS_H = 1920;

export default function CanvasToolbar({ selectedElement, dispatch }) {
  const [{ pages }] = useLanguage();
  const tt = (pages.overlayTemplates || {}).toolbar || {};
  const disabled = !selectedElement;

  const btn = (title, icon, onClick) => (
    <Tooltip title={title}>
      <span>
        <IconButton size="small" onClick={onClick} disabled={disabled}>
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  );

  const centerH = () => {
    if (!selectedElement) return;
    dispatch({ type: "UPDATE", id: selectedElement.id, patch: { x: Math.round((CANVAS_W - selectedElement.w) / 2) } });
  };

  const centerV = () => {
    if (!selectedElement) return;
    dispatch({ type: "UPDATE", id: selectedElement.id, patch: { y: Math.round((CANVAS_H - selectedElement.h) / 2) } });
  };

  const fillCanvas = () => {
    if (!selectedElement) return;
    dispatch({ type: "UPDATE", id: selectedElement.id, patch: { x: 0, y: 0, w: CANVAS_W, h: CANVAS_H } });
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        px: 1,
        py: 0.5,
        bgcolor: "background.paper",
        borderBottom: "1px solid",
        borderColor: "borderColor.default",
        flexShrink: 0,
      }}
    >
      {btn(tt.centerH || "Center Horizontally", <AlignHorizontalCenterIcon fontSize="small" />, centerH)}
      {btn(tt.centerV || "Center Vertically", <AlignVerticalCenterIcon fontSize="small" />, centerV)}
      {btn(tt.fillCanvas || "Fill Canvas", <FitScreenIcon fontSize="small" />, fillCanvas)}

      <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />

      {btn(tt.bringForward || "Bring Forward", <KeyboardArrowUpIcon fontSize="small" />, () => selectedElement && dispatch({ type: "BRING_FORWARD", id: selectedElement.id }))}
      {btn(tt.sendBackward || "Send Backward", <KeyboardArrowDownIcon fontSize="small" />, () => selectedElement && dispatch({ type: "SEND_BACKWARD", id: selectedElement.id }))}
      {btn(tt.bringFront || "Bring to Front", <VerticalAlignTopIcon fontSize="small" />, () => selectedElement && dispatch({ type: "BRING_FRONT", id: selectedElement.id }))}
      {btn(tt.sendBack || "Send to Back", <VerticalAlignBottomIcon fontSize="small" />, () => selectedElement && dispatch({ type: "SEND_BACK", id: selectedElement.id }))}

      <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />

      {btn(tt.duplicate || "Duplicate", <ContentCopyIcon fontSize="small" />, () => selectedElement && dispatch({ type: "DUPLICATE", id: selectedElement.id }))}
      {btn(tt.delete || "Delete", <DeleteOutlineIcon fontSize="small" />, () => selectedElement && dispatch({ type: "REMOVE", id: selectedElement.id }))}
    </Box>
  );
}
